import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import { deleteEntries, isEquivalent } from 'AppSrc/core/utility-functions/array-fun';
import { InlineErrors } from './sub-components/inline-errors';
import { FieldTitle } from './sub-components/field-title';
import {
  vFParamsPropShape,
  vFButtonSelectorOptionShape,
  disabledFieldOptionsShape,
} from './data-structure/v-f-proptypes';
import {
  getFieldPropShape,
  formPropShape,
} from './data-structure/formik-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/v-f-button-selector.css';


class VFButtonSelector extends PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.ifDisabledSetDefaultValues({});
  }

  componentDidUpdate(prevProps) {
    this.ifDisabledSetDefaultValues({
      prevProps,
    });
  }

  onChange(selectedIndex) {
    const {
      vFParams,
      field,
      displayOptions,
      updateValue: updateValueFromProps,
      form,
    } = this.props;

    const {
      multiSelect,
    } = vFParams;

    const {
      name,
      value = [],
    } = field;

    const valueToAdd = displayOptions[selectedIndex].value;
    // Toggles a selected value

    let multiSelectValue = [];

    // If this is a new value, add it to the newValue array

    if (value && value.includes(valueToAdd)) {
      multiSelectValue = deleteEntries(value, valueToAdd);
    }
    else {
      multiSelectValue = [
        ...value,
        valueToAdd,
      ];
    }

    const singleSelectValue = multiSelectValue.length > 1 ? [valueToAdd] : multiSelectValue;

    // overwrites the default setter using a call back in the form section (such as section-one)
    if (updateValueFromProps) {
      updateValueFromProps({
        form,
        thisField: field,
        newValue: multiSelect ? multiSelectValue : singleSelectValue,
      });
      return null;
    }

    if (multiSelect) {
      this.props.form.setFieldValue(name, multiSelectValue);
      this.props.form.setFieldTouched(name, true);
      return null;
    }

    // const singleSelectValue = multiSelectValue.length > 1 ? [valueToAdd] : multiSelectValue;
    this.props.form.setFieldValue(name, singleSelectValue);
    this.props.form.setFieldTouched(name, true);
    return null;
  }

  ifDisabledSetDefaultValues(params) {
    const {
      prevProps,
    } = params;
    const {
      name,
      value,
    } = this.props.field;
    const {
      disabled,
      disabledValue,
      unDisabledValue,
    } = this.props.disabledFieldOptions;
    // check if the previous props had set it to disabled
    const prevDisabled = prevProps ? prevProps.disabledFieldOptions.disabled : false;

    if (!disabled) {
      if (prevDisabled) {
        this.props.form.setFieldValue(name, unDisabledValue);
        this.props.form.setFieldTouched(name, true);
      }
      return null;
    }

    const isSetToDisabledValue = isEquivalent(value, disabledValue);

    if (!isSetToDisabledValue) {
      this.props.form.setFieldValue(name, disabledValue);
      this.props.form.setFieldTouched(name, true);
    }
    return null;
  }

  render() {
    const {
      vFParams,
      field,
      form,
      displayOptions,
      disabledFieldOptions,
      optional,
      readOnly,
    } = this.props;

    const {
      name,
      value,
    } = field;

    const {
      disabled,
    } = disabledFieldOptions;

    const formErrors = form.errors;
    const touched = form.touched[name];


    const errors = formErrors[name];

    const inlineErrors = errors && errors.inlineErrors ? errors.inlineErrors : null;

    const {
      fieldTitle,
      displayType,
    } = vFParams;

    // We don't display the field title if the display is 'big'
    // However we still need to provide a field title for the summary page
    const displayFieldTitle = fieldTitle && displayType !== 'big';

    // unforunatley default props doesn't work with nested data so we have to state a default here
    const displayClassName = displayType ? displayType : 'standard';

    const classNameBase = 'v-f-button-selector';

    const classNameForChageType = 'v-f-change-type-btn';

    const classNameList = [
      'v-f-field-type',
      classNameBase,
      `${classNameBase}-${displayClassName}`,
      `${classNameBase}-${name}`,
    ];

    if (disabled) {
      classNameList.push(`${classNameBase}-disabled`);
    }
    if (readOnly) {
      classNameList.push(`${classNameBase}-read-only`);
    }

    if (fieldTitle === 'Select network') {
      classNameList.push(classNameForChageType);
    }

    const className = classNameList.join(' ');

    return (
      <div
        className={className}
        name={name}
      >
        {
          displayFieldTitle && (
            <FieldTitle
              fieldTitle={fieldTitle}
              optional={optional}
            />
          )
        }

        <div className="button-options">
          {
            displayOptions && displayOptions.map((option, i) => (
              <div
                className="button-option-wrapper"
                key={option.value}
              >
                <OptionButton
                  className={`button-option ${value && value.includes(option.value) ? 'button-option-selected' : ''}`}
                  onClick={this.onChange}
                  option={i}
                  // buttons cannot be readonly, but disabled is basically the same thing
                  disabled={disabled || readOnly}
                >
                  <p>{option.text}</p>
                </OptionButton>
              </div>
            ))
          }
          {
            inlineErrors && touched && (
              <InlineErrors
                inlineErrors={inlineErrors}
              />
            )
          }
        </div>
      </div>
    );
  }
}

VFButtonSelector.propTypes = {
  vFParams: vFParamsPropShape,
  // we have to define the value within the data structure for field
  field: getFieldPropShape(PropTypes.array),
  form: formPropShape,
  displayOptions: PropTypes.arrayOf(vFButtonSelectorOptionShape),
  disabledFieldOptions: disabledFieldOptionsShape,
  optional: PropTypes.bool,
  readOnly: PropTypes.bool,
  updateValue: PropTypes.func,
};

const noValueVFButtonSelector = (value) => (value.length < 1);
// This is a reference to the component. This is needed as the value for each form field is displayed on a change summary
// page but this is dependant on what type of form field is used
const VF_BUTTON_SELECTOR = 'v-f-button-selector';

export {
  VF_BUTTON_SELECTOR,
  VFButtonSelector,
  noValueVFButtonSelector,
};
